export class ProfileFull {
  profile: any
  profilePng: any
}
